import React from 'react';
import { Button, Space } from 'antd';
import Analytics from './Analytics';
import UserList from './UserList';
import Layout from '../Layout';

import './AdminBoard.css';
import { Route, useHistory, useParams } from 'react-router-dom';

function AdminContent() {
  const history = useHistory();
  const params = useParams<{ page: string }>();

  return (
    <Layout>
      <div className='admin-content-main-component'>
        <div className='content-top-panel'>
          <Space.Compact>
            <Button
              onClick={() => {
                history.push('/admin/users');
              }}
              className={params.page === 'users' ? 'active' : ''}
            >
              Users
            </Button>
            <Button
              onClick={() => {
                history.push('/admin/analytics');
              }}
              className={params.page === 'analytics' ? 'active' : ''}
            >
              Analytics
            </Button>
          </Space.Compact>
        </div>
        <div className='content-body'>
          <Route path='/admin/analytics' component={Analytics} />
          <Route path='/admin/users' component={UserList} />
        </div>
      </div>
    </Layout>
  );
}

export default AdminContent;
